// @ts-nocheck
import clsx from 'clsx'
import {FC} from 'react'
import {Row} from 'react-table'
import {Servicecenter} from '../../core/_models'

type Props = {
  row: Row<Servicecenter>
  style:any
}

const CustomRow: FC<Props> = ({row, style,key}) => (
  <tr {...row.getRowProps({
    style
  })}>
    {row.cells.map((cell) => {
      return (
        <td
          {...cell.getCellProps()}
          className={clsx({'text-end min-w-100px': cell.column.id === 'actions'})}
          
        >
          {cell.render('Cell')}
        </td>
      )
    })}
  </tr>
)

export {CustomRow}
